
export namespace Draft2018 {
    export class Load {
        static readonly type = '[Draft2018] Load';
    }
}